import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-status-title',
  templateUrl: './status-title.component.html',
  styleUrls: ['./status-title.component.scss']
})
export class StatusTitleComponent  {
  templateSuffix = environment.templateSuffix;
  @Input()
  text: string = '';

  @Input()
  color: string = '#000';

}
